import type { TCredenzaPublicClientUISettings } from "../types/client";

type NavbarUiSettings = Pick<
  TCredenzaPublicClientUISettings,
  "navbar_image_url" | "navbar_logged_in_image_url"
>;

/**
 * Resolve which navbar override image to show.
 * Fallback: if only one URL is set, it is used for both logged-in and logged-out.
 */
export function resolveNavbarOverrideImage(
  ui_settings: NavbarUiSettings | undefined | null,
  isLoggedIn: boolean,
): string | undefined {
  if (!ui_settings) return undefined;
  const loggedOut = ui_settings.navbar_image_url;
  const loggedIn = ui_settings.navbar_logged_in_image_url;
  const resolved = isLoggedIn
    ? loggedIn || loggedOut
    : loggedOut || loggedIn;
  return resolved || undefined;
}
